import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  label: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  children: PropTypes.node,
}

// Add any default values for props
const defaultProps = null

function Anchor({ label, children, href, target, title, ...rest }) {
  return (
    <a
      href={href}
      target={target}
      title={title !== label ? title : undefined}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      {...rest}
    >
      {children || label}
    </a>
  )
}

Anchor.displayName = 'Anchor'
Anchor.propTypes = propTypes
Anchor.defaultProps = defaultProps

export default Anchor



// WEBPACK FOOTER //
// ./src/components/Anchor/Anchor.js